import React, { useEffect, useState, useMemo, useContext } from 'react';
import { LocationContext } from '../../context/LocationContext.js';
import useFetchWithParams from '../../services/useFetchWithParams.js'
import { DataGrid, GridToolbarContainer, GridToolbarQuickFilter, GridToolbarExport } from "@mui/x-data-grid"
import DatePicker from '../TimeDataTable/DatePicker.jsx';
import { format } from 'date-fns';

export default function ItemSalesTable() {
    const { locationAccess } = useContext(LocationContext)
    const [reload, setReload] = useState(true)
    const [dateFilter, setDateFilter] = useState({ s: null, e: null, loc: locationAccess?.length > 0 ? locationAccess?.[0] : null })

    // const { data, load, error } = useFetchWithParams('retrieve-itemsales', dateFilter, reload, setReload)
    const { data, load, error } = useFetchWithParams('retrieve-itemsales', dateFilter, reload, setReload)
    console.log(data)
    const row = useMemo(() => {
        if (data === null) {
            return [];
        }
        return data.map((e, ind) => {

            return ({
                id: ind,
                itemName: e.name,
                // regHours: e.hours,
                qty: e.totQuantity,
            })
        });
    }, [data]);

    const col = useMemo(() => [
        { field: 'itemName', headerName: 'Name', flex: .5 },
        { field: 'qty', headerName: 'Quantity', flex: 1 },
    ], []);

    // const updateFilters = (filters) => {
    //     setDateFilter({ s: filters.dates.start, e: filters.dates.end, loc: filters.locs })
    //     setReload(true)
    // }
    const updateFilters = (filters) => {
        setDateFilter({ s: filters.dates.start, e: filters.dates.end, loc: filters.locs })
        setReload(true); // Explicitly set reload to true to trigger fetch via useFetchWithParams's enabled prop
    }

    useEffect(() => {
        if (dateFilter) {
            setReload(true)
        }
    }, [dateFilter])

    function CustomToolbar() {
        const locName = dateFilter.loc?.[0].replace(/'/g, '').replace(/ /g, '');
        const formattedStartDate = dateFilter?.s ? format(new Date(dateFilter.s), 'MMddyyyy') : 'startDate';
        const formattedEndDate = dateFilter?.e ? format(new Date(dateFilter.e), 'MMddyyyy') : 'endDate';
        const fileName = `${locName}_item-sales_${formattedStartDate}_${formattedEndDate}`;

        return (
            <GridToolbarContainer>

                {/* <UserLocation /> */}
                <div className="col-xl-2 col-lg-3 me-auto d-flex align-items-center">

                    <GridToolbarExport
                        csvOptions={{ fileName: fileName }}
                        sx={{
                            height: '32px',
                            border: 'solid #e2e2e2',
                            borderWidth: '1px',
                            borderRadius: '5px',
                            fontSize: "small",
                            fontWeight: '450',
                            lineHeight: '10px',
                            padding: '0 8px', // Adjust padding to visually match
                            color: '#00000091', // Match text color
                            '& .MuiButton-root': { // Target the inner Button component
                                padding: '5px 0',
                                minWidth: 'unset', // Remove minimum width constraint if any
                                '& .MuiButton-startIcon': {
                                    marginRight: '4px', // Adjust icon spacing if needed
                                },
                            },
                        }}
                    />
                </div>

                <GridToolbarQuickFilter
                    variant="outlined"
                    size="small"
                    sx={{
                        '@media (max-width: 600px)': {
                            width: '100%', // Full width on smaller screens                            
                        },
                        border: 'solid #e2e2e2', borderWidth: '1px', borderRadius: '5px', width: '225px', padding: '0', height: '32px',
                        '&.MuiFormControl-root': {
                            margin: '0'
                        }, '& .MuiOutlinedInput-root': {
                            '& fieldset': {
                                borderColor: 'transparent', // Removes the default border color
                            },
                            '&:hover fieldset': {
                                borderColor: 'transparent',
                                backgroundColor: "#1976d20a" // Keeps the border color transparent on hover
                            },
                            '&.Mui-focused fieldset': {
                                borderColor: 'transparent', // Ensures the border color remains the same when focused
                            },
                            '& .MuiSvgIcon-root': { color: '#e2e2e2' },
                            '&.MuiInputBase-root input': { fontSize: 'small', color: '#7c7a7a', padding: '5px 0' }
                        }
                    }}
                />

            </GridToolbarContainer>
        );
    }
    return (
        <div style={{ display: "flex", flexDirection: "column", height: "calc(100vh - 100px", }}>
            <div className="sticky-header">
                <div className='row pg-hdr' style={{ width: "100%" }}>
                    <div className="col-xl-9 col-lg-8 col-md-8" >
                        <h2 style={{ margin: 0, paddingTop: '10px' }}>Item Sales</h2>
                    </div>
                </div>
                <hr style={{ margin: '0', marginBottom: '0', width: "100%" }} />

                {/* <hr style={{ margin: '0' }} /> */}
            </div>
            {/* <div className='row m-0' style={{ paddging: '0' }}> */}
            <div className='row m-0' style={{ height: '50px', padding: "10px 15px 0" }}>
                <DatePicker newFilters={(f) => updateFilters(f)} />
            </div>

            <div className='row m-0' style={{ flexGrow: 1, minHeight: 0, padding: "0 15px" }}>
                <div className="col-12" style={{ padding: '10px 0', height: '100%', boxSizing: 'border-box' }} >
                    <DataGrid
                        rows={row}
                        columns={col}
                        rowHeight={35}
                        pageSize={10}
                        loading={load}
                        pageSizeOptions={[10, 25]}
                        slots={{
                            toolbar: CustomToolbar
                        }}
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 25,
                                },
                            },
                        }}
                        sx={{
                            padding: "10px 0 0 0", border: "none", overflowY: "scroll",
                            '& .MuiToolbar-root': { alignItems: "baseline" },
                            '& .MuiSvgIcon-root': { margin: 0 },
                            '& .MuiDataGrid-main': { marginRight: 0 },
                            '&.MuiDataGrid-root': {
                                padding: '10px', marginTop: '10px',
                                boxShadow: "0rem .3125rem .3125rem -.15625rem rgba(0, 0, 0, .03), 0rem .1875rem .1875rem -.09375rem rgba(0, 0, 0, .02), 0rem .125rem .125rem -.0625rem rgba(0, 0, 0, .02), 0rem .0625rem .0625rem -.03125rem rgba(0, 0, 0, .03), 0rem .03125rem .03125rem 0rem rgba(0, 0, 0, .04), 0rem 0rem 0rem .0625rem rgba(0, 0, 0, .06)",
                                borderRadius: '10px'
                            },
                            '& .MuiDataGrid-columnHeaders': { minHeight: '30px', maxHeight: '30px' },
                            '& .MuiDataGrid-columnHeaderTitle': {
                                fontSize: '13px', fontWeight: '600',
                                '@media (max-width:1080px)': { fontSize: '11px' }
                            },
                            '&.MuiDataGrid-toolbarContainer': { justifyContent: 'flex-end', marginRight: "10px" },
                            '& .MuiDataGrid-cellContent': { fontSize: "small" }
                        }}
                    />
                </div>
            </div >
            {/* </div> */}

        </div>
    );
};
